import {connect} from 'react-redux'
import {fetchLogin, fetchLogout, setAgent} from '../actions/userActions'
import LoginWidget from '../components/LoginWidget'

const mapStateToProps = (state) => {    
  return {
    isLogged: state.user.isLogged,
    userFullName: state.user.userName,
    agentFullName: state.user.agentName,
    agents: state.user.agents,
    agentLogin: state.user.agentLogin,
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    onLogin: (ownProps) => {      
      const loginData = {
        username: ownProps.username, 
        password: ownProps.password
      }      
      //dispatch(setLoginData(loginData))
      dispatch(fetchLogin(loginData))
    },
    onLogout: () => {
      dispatch(fetchLogout())      
      //dispatch(logout())
    },
    onChangeAgent: (ownProps) => {
      dispatch(setAgent(ownProps))
    }
  }
}

const AppLoginWidget=connect(
  mapStateToProps,
  mapDispatchToProps
)(LoginWidget)

export default AppLoginWidget


// WEBPACK FOOTER //
// ./src/containers/AppLoginWidget.js